import { render } from "./PlaceRouting.vue?vue&type=template&id=70e7b2fe&scoped=true"
import script from "./PlaceRouting.vue?vue&type=script&lang=js"
export * from "./PlaceRouting.vue?vue&type=script&lang=js"

import "./PlaceRouting.vue?vue&type=style&index=0&id=70e7b2fe&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e7b2fe"]])

export default __exports__